/* src/app/views/live-view/print-cards/print-card-live-view/print-card-live-view.component.scss */
:host {
  display: contents;
}
/*# sourceMappingURL=print-card-live-view.component.css.map */
